var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
let MouldingSearchForm = class MouldingSearchForm extends Vue {
    constructor() {
        super(...arguments);
        this.orderIconName = 'arrow_downward';
        this.formData = {
            colour: 0,
            profile: 0,
            widthFrom: 0,
            widthTo: 0,
            minMetres: 0,
            orderBy: 'recentlyAdded',
            orderDirection: 'DESC'
        };
    }
    toggleDirection() {
        if (this.formData.orderDirection == 'DESC') {
            // Make ASC
            this.formData.orderDirection = 'ASC';
            this.orderIconName = 'arrow_upward';
        }
        else {
            // Make DESC
            this.formData.orderDirection = 'DESC';
            this.orderIconName = 'arrow_downward';
        }
    }
    search() {
        this.$emit("search", this.formData);
    }
    get urlParams() {
        var _a;
        let params = new URLSearchParams(window.location.search);
        return {
            colour: parseInt(params.get('colour') || "0"),
            profile: parseInt(params.get('profile') || "0"),
            widthFrom: parseInt(params.get('widthFrom') || "0"),
            widthTo: parseInt(params.get('widthTo') || (((_a = this.maxWidth) === null || _a === void 0 ? void 0 : _a.toString()) || "99999")),
            minMetres: parseInt(params.get('minMetres') || "0"),
        };
    }
    mounted() {
        let slider = document.getElementById('widthSlider');
        if (!slider) {
            return;
        }
        let dimensionFormat = wNumb({
            decimals: 0,
            mark: '.',
            thousand: ',',
            suffix: 'mm'
        });
        this.formData.widthTo = this.maxWidth || 130;
        noUiSlider.create(slider, {
            start: [0, this.maxWidth || 130],
            connect: [false, true, false],
            tooltips: [dimensionFormat, dimensionFormat],
            step: 5,
            margin: 50,
            range: {
                'min': 0,
                'max': this.maxWidth || 130
            }
        }).on('update', values => {
            this.formData.widthFrom = values[0];
            this.formData.widthTo = values[1];
        });
        this.formData = Object.assign(this.formData, this.urlParams);
        this.$emit('search', this.formData);
    }
};
__decorate([
    Prop(Number)
], MouldingSearchForm.prototype, "maxWidth", void 0);
__decorate([
    Prop(Array)
], MouldingSearchForm.prototype, "colours", void 0);
__decorate([
    Prop(Array)
], MouldingSearchForm.prototype, "profiles", void 0);
MouldingSearchForm = __decorate([
    Component
], MouldingSearchForm);
export default MouldingSearchForm;
